<template>
	<div id="apps">
		<!-- 头部 -->
		<HeaderTopView @childFn="parentFn($event)"></HeaderTopView>
		<HeaderView></HeaderView>
		<NavView></NavView>
		<!-- 内容 -->
		<div class="word" v-if="solutionArr.length > 0">
		<view></view>
			<div class="list_dv">
				<ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto">
					<li v-for="(item,index) in solutionArr" :key="index" @click="choice(index)" class="el-collapse-item__content infinite-list-item">
						<div :class="index == idx?'c':''">{{item.schemeName}}</div>
					</li>
				</ul>
			</div>
			<div class="dv">
				<div class="box">
					<div class="title flex_between">
						<span>{{solutionArr[idx].schemeName}}</span>
						<el-button type="primary" size="small" @click="detalis">立即购买</el-button>
					</div>
					<div v-html="msg" style="text-align: left;"></div>
				</div>
			</div>
		</div>
		<div class="no" v-if="solutionArr.length == 0">暂无数据</div>
		<!-- 底部 -->
		<Footer></Footer>
	</div>
</template>

<script>
	import HeaderTopView from '@/components/assembly/HeaderTop.vue'; //头部模块
	import HeaderView from '@/components/assembly/Header.vue'; //头部模块
	import NavView from '@/components/assembly/Nav.vue'; //导航模块
	import Footer from '@/components/assembly/Footer.vue'; //导航模块
	export default {
		name: "AboutUs",
		data() {
			return {
				msg: '',
				solutionArr: [],
				idx: 0,
				count: 0,
				item: {},
				pageNum:1
			}
		},
		components: {
			HeaderView,
			NavView,
			HeaderTopView,
			Footer
		},
		methods: {
			load() {
				if (this.solutionArr.length == this.count) {
					return false
				}
				this.pageNum += 1
				this.solutionList()
			},
			handleChange(val) {
				console.log(val);
			},
			choice(index) {
				this.idx = index
				this.item = this.solutionArr[index]
				this.solutionDetails()
			},
			// 产品详情
			detalis() {
				this.$router.push({
					path: "/GoodsDetails",
					query: {
						id: this.item.productId
					}
				});
			},
			// 解决方案列表
			solutionList() {
				let url = "/open/schemeList";
				let data = {
					pageNum: this.pageNum,
					pageSize: 10
				};
				this.$post(url, data).then(res => {
					this.solutionArr = this.solutionArr.concat(res.rows) 
					this.item = this.solutionArr[this.idx]
					this.count = res.total
					this.solutionDetails()
				});
			},
			// 解决方案详情
			solutionDetails() {
				let url = "/open/detail";
				let data = {
					schemeId: this.solutionArr[this.idx].schemeId
				};
				this.$get(url, data).then(res => {
					this.msg = res.data.remark
				});
			}
		},
		mounted() {
			this.idx = this.$route.query.index ? this.$route.query.index : 0
			this.solutionList()
		}
	}
</script>

<style scoped>
	#apps {
		background: #F6F6F6;
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}
	.no{
		padding: 50px;
	}
	ul,
	li {
		padding: 0;
		margin: 0;
		list-style: none
	}

	.list_dv {
		background: #fff;
		margin-right: 20px;
		max-height: 1000px;
		min-width: 220px;

	}

	.list_dv ul {
		height: 100%;
	}

	.list_dv ul::-webkit-scrollbar {
		display: none;
		/* Chrome Safari */
	}

	.c {
		color: #0090ff;
	}

	.word {
		margin-top: 10px;
		display: flex;
		flex: 1;
	}

	.el-collapse {
		width: 200px;
	}

	.word>>>.el-collapse-item__header {
		background-color: #EAEAEA;
		padding: 0 20px;
		font-size: 13rpx;
		border-bottom: solid 1px #fff;
	}

	.word>>>.el-collapse-item__content {
		padding-bottom: 0;
	}

	.el-collapse-item__content div {
		text-align: left;
		padding: 10px 20px;
		border-bottom: solid 1px #f5f5f5;
		cursor: pointer;
		font-size: 12px;
		box-sizing: border-box;
	}

	.el-collapse-item__content div:hover {
		color: #0090ff;
	}

	.dv {
		width: 100%;
	}

	.el-breadcrumb {
		background: #eaeaea;
		padding: 0 20px;
		line-height: 49px;
	}

	.box {
		padding: 20px;
		background: #fff;
	}

	.title {
		border-bottom: 1px solid #e4e4e4;
		/* padding-bottom: 12px; */
		font-weight: 700 !important;
		font-size: 14px;
		text-align: left;
		position: relative;
		margin-bottom: 10px;
	}

	.title span {
		border-bottom: 2px solid #0090ff;
		padding-bottom: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/solution/solution.vue